export const cart = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13.054"
        height="15.067"
        viewBox="0 0 13.054 15.067"
    >
        <g id="bag" transform="translate(-3.005 -0.995)">
            <path
                id="Path_7734"
                data-name="Path 7734"
                d="M16.056,13.1l-.91-8.743a1.5,1.5,0,0,0-1.5-1.351H11.991a2.511,2.511,0,0,0-4.921,0H5.413a1.5,1.5,0,0,0-1.5,1.35L3,13.1v.05a2.916,2.916,0,0,0,2.91,2.913h7.231a2.916,2.916,0,0,0,2.913-2.913A.446.446,0,0,0,16.056,13.1ZM9.531,2a1.509,1.509,0,0,1,1.421,1H8.11A1.509,1.509,0,0,1,9.531,2Zm3.616,13.056H5.915a1.908,1.908,0,0,1-1.908-1.884l.908-8.712a.5.5,0,0,1,.5-.452h8.235a.5.5,0,0,1,.5.452l.9,8.712a1.908,1.908,0,0,1-1.908,1.884Z"
                fill="#fff"
            />
            <path
                id="Path_7735"
                data-name="Path 7735"
                d="M15.519,11a.5.5,0,0,0-.5.5A1.506,1.506,0,1,1,12,11.5a.5.5,0,0,0-1,0,2.511,2.511,0,1,0,5.022,0A.5.5,0,0,0,15.519,11Z"
                transform="translate(-3.98 -4.981)"
                fill="#fff"
            />
        </g>
    </svg>
);
export const check = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="18.2"
        viewBox="0 0 14 10.2"
    >
        <path
            id="check"
            d="M18.7,7.2a.967.967,0,0,0-1.4,0L9.8,14.7,6.7,11.6A.99.99,0,0,0,5.3,13l3.8,3.8a.967.967,0,0,0,1.4,0l8.2-8.2a.967.967,0,0,0,0-1.4Z"
            transform="translate(-5 -6.9)"
            fill="#fff"
        />
    </svg>
);
